import React from "react";
import { makeStyles } from "@material-ui/core";


let useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    gridIcons: {
        width: 100,
        height: 100,
        borderRadius: '50%',
        background: "#EDEEFE",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },

    icons: {
        width: "35%",
        // height: 36,
    },
    title: {
        fontSize: 16,
        margin:'20px auto'
    },
    card: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        borderRadius: 40,
        marginBottom:10,
        padding:'5px 8px',
    },
    gridCircle: {
        width: 60,
        height: 50,
        borderRadius: '50%',
        backgroundColor: '#EAEAFF',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 5
    },
    indexStep: {
        margin: 0,
        fontSize: 26,
        fontWeight:'bold',
    },
    desc: {
        margin: 'auto',
        textAlign: 'center',
        width:'80%'
    },
    gridbtn: {
        width: '100%',
        backgroundColor:'#EAEAFF',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius:38,
        height:60,
        marginBottom:50,
        cursor:'pointer'
    },
    btns: {
        margin: 0,
        color: '#182551',
        fontSize:16,
        marginRight:10
    },
    gridTitle:{
        width:'100%',
        textAlign:'center'
    },
  
}))

export default function Index({ data }) {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            {/* <div className={classes['gridIcons']}>
                <img src={data?.iconTitle} alt="" className={classes['icons']} />
            </div> */}
            <div>
                <h3 className={classes['title']}>
                    {data?.title}
                </h3>
            </div>
            <div>
                {
                    data?.data?.map((item, index) => {
                        return (
                            <div className={classes['card']} key={index}>
                                <div className={classes['gridCircle']}>
                                    <p className={classes['indexStep']}>
                                        {index + 1}
                                    </p>
                                </div>
                                <div className={classes['gridTitle']}>
                                    <p className={classes['desc']}>
                                        {item?.title}
                                    </p>
                                </div>

                            </div>
                        )
                    })
                }
            </div>
            {/* <div className={classes['gridbtn']}>
                <p className={classes['btns']}>
                    {data?.btnDesc}
                </p>
                <img src="/assets/icons/kala/arrow.svg" alt="" className={classes['iconArrow']} />
            </div> */}
        </div>)
}
